import { useUpdate } from "@refinedev/core";
import { Power } from "lucide-react";
import { toast } from "sonner";

interface Props {
  resource: string;
  id: string;
  activo: boolean;
  /** Si se pasa, se confirma antes de desactivar (no cuando se reactiva). */
  confirmarTexto?: string;
}

/**
 * Botón de toggle para el campo `activo` de un recurso.
 * - Activo (verde): clic → desactiva (pide confirmación si confirmarTexto).
 * - Inactivo (gris): clic → reactiva sin pedir confirmación.
 */
export function ToggleActivo({ resource, id, activo, confirmarTexto }: Props) {
  const { mutate, isLoading } = useUpdate();

  function onClick() {
    if (activo && confirmarTexto) {
      if (!window.confirm(confirmarTexto)) return;
    }
    mutate(
      {
        resource,
        id,
        values: { activo: !activo },
        successNotification: false,
        errorNotification: false,
      },
      {
        onSuccess: () => toast.success(activo ? "Desactivado" : "Activado"),
        onError: (err) => toast.error("Error", { description: err.message }),
      },
    );
  }

  return (
    <button
      type="button"
      onClick={onClick}
      disabled={isLoading}
      className={`p-2 rounded-md transition-colors ${
        activo
          ? "text-success hover:bg-success/10"
          : "text-fg-muted hover:bg-bg-hover"
      }`}
      title={activo ? "Desactivar" : "Activar"}
      aria-label={activo ? "Desactivar" : "Activar"}
    >
      <Power className="size-4" />
    </button>
  );
}
